
import { session } from 'wix-storage';
import { toggleFilters } from './filtersMenu';
import { SITE_COLORS } from './siteColors'
import { getAllFilterdSites } from 'backend/queries.jsw';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

export function populateLayouters(tagsFromSession) {

    let layouterFilterMenuTags = [...$w('#tagsBox01').children, ...$w('#tagsBox02').children];
    let indexofItem;
    checkClickedArray();
    if (tagsFromSession.length > 0) {
        tagsFromSession.forEach((tag) => {
            layouterFilterMenuTags.forEach((item) => {

                if (item.children[0].text === tag) {

                    item.children[0].html = `<span style='color:#ffffff;font-size:16px;font-family:madefor-display-bold'>${item.children[0].text}</span>`
                }
            })
        })
    }

    layouterFilterMenuTags.forEach((item) => {

        item.onClick(() => {
            wixWindow.getBoundingRect()
                .then((windowSizeInfo) => {

                    let windowWidth = windowSizeInfo.window.width; // 1269

                    let fontSize = (windowWidth < 751) ? 14 : 16;

                    let itemText = item.children[0].text;
                    indexofItem = tagsFromSession.indexOf(itemText);

                    if (indexofItem === -1) {
                        item.children[0].html = `<span style='color:#ffffff;font-size:${fontSize}px;font-family:madefor-display-bold'>${itemText}</span>`
                        tagsFromSession.push(itemText);

                    } else {
                        item.children[0].html = `<span style='color:#ababab;font-size:${fontSize}px;font-family:madefor-display'>${itemText}</span>`
                        tagsFromSession.splice(indexofItem, 1);
                    }
                    checkClickedArray();
                });

        })
    })

    $w('#clearFiltersBtn').onClick(() => {
        tagsFromSession = [];
        layouterFilterMenuTags.forEach((item) => {
            let itemText = item.children[0].text;
            item.children[0].html = `<span style='color:#ababab;font-size:16px;font-family:madefor-display'>${itemText}</span>`
        })
        wixLocation.to('/inspiration');
    });

    $w('#filterBtn').onClick(() => {

        session.setItem("filterArray", JSON.stringify(tagsFromSession));
        getAllFilterdSites(tagsFromSession).then((data) => {
            updateRepeatersAndTopTags(data, 1) ? $w('#seeMoreSection').collapse() : $w('#seeMoreSection').expand();
        })
        toggleFilters();

    })

    function checkClickedArray() {
        tagsFromSession.length > 0 ? $w('#filterBtn').enable() : $w('#filterBtn').disable();
    }

}

export function updateRepeatersAndTopTags(data, seeMoreClicked) {
    //update repeater

    let totalPages = Math.ceil(data.unique.length / 9);

    let repeaterArray;
    let lastClick = false;

    if (seeMoreClicked < totalPages) {

        repeaterArray = data.unique.slice(0, (9 * seeMoreClicked));
        updateAfterSlice();

        return lastClick;
    } else {

        repeaterArray = data.unique;
        lastClick = true;
        updateAfterSlice();

        return lastClick;
    }

    function updateAfterSlice() {
        $w('#filterRepeater').data = repeaterArray;

        $w('#filterMenuTags').children.forEach((item) => {
            item.collapse();
        })
        //update top tags
        if (data.tags.length > 0) {
            data.tags.forEach((tag, index) => {

                

                let encodedTagTitle = encodeURI(tag.title).replace(/%20/g," ");

                $w('#filterMenuTags').children[index].children[0].html = `<p><a href="${tag['link-tags-1-titleForUrl']}">${encodedTagTitle}</a></p>`;
                if (tag.tagType === 'Site type') {
                    $w('#filterMenuTags').children[index].children[1].style.backgroundColor = SITE_COLORS.typeSite.background;
                }
                $w('#filterMenuTags').children[index].expand();

            })
        }
    }

}

export function showTags(tagsInfo, tagsWrappers) {

    if (tagsInfo !== undefined) {

        tagsInfo.sort(function (a, b) {
            var nameA = a.tagType.toUpperCase(); // ignore upper and lowercase
            var nameB = b.tagType.toUpperCase(); // ignore upper and lowercase

            if (nameA < nameB) {
                return 1;
            }
            if (nameA > nameB) {
                return -1;
            }

            // names must be equal
            return 0;
        });

        tagsInfo.splice(6)


        if (tagsInfo[2]) {
            tagsInfo[0].title.length + tagsInfo[1].title.length + tagsInfo[2].title.length > 35 ? tagsInfo[2].title = '' : {}
        }

        if (tagsInfo[5]) {
            tagsInfo[3].title.length + tagsInfo[4].title.length + tagsInfo[5].title.length > 35 ? tagsInfo[5].title = '' : {}
        }


        for (let i = 0; i < tagsInfo.length; i++) {
            if (tagsInfo[i].title !== '') {
                tagsWrappers[i].children[0].html = `<p><a href="${tagsInfo[i]['link-tags-1-titleForUrl']}">${tagsInfo[i].title}</a></p>`; // children[0] = Text

                if (tagsInfo[i].tagType === 'Site type') {
                    tagsWrappers[i].children[1].style.backgroundColor = SITE_COLORS.typeSite.background; // children[0] = Dot container
                } else {
                    tagsWrappers[i].children[1].style.backgroundColor = SITE_COLORS.featureSite.background; // 
                }

                tagsWrappers[i].expand();
            }

        }

    }

}